export default "__VITE_ASSET__CmGvn7eM__"